<app-navbar></app-navbar>

<div class="wrapper">
  <router-outlet></router-outlet>
  <div id="scroll-percentage">
    <span>{{ scrollPercent }}%</span>
  </div>

  <ngx-scrolltop></ngx-scrolltop>

</div>

<app-footer *ngIf="showFooter"></app-footer>
